import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function listApplications() {
  const { data } = await axiosClient.get("/api/admin/applications");
  return unwrapApiResponse({ data });
}

export async function getApplication(id) {
  const { data } = await axiosClient.get(`/api/admin/applications/${id}`);
  return unwrapApiResponse({ data });
}

export async function markApplicationRead(id, isRead) {
  const { data } = await axiosClient.patch(
    `/api/admin/applications/${id}/read`,
    { isRead }
  );
  return unwrapApiResponse({ data });
}

export async function deleteApplication(id) {
  const { data } = await axiosClient.delete(`/api/admin/applications/${id}`);
  return unwrapApiResponse({ data });
}
